<div class="row">
  <div class="col-1 d-flex align-items-center justify-content-center"></div>
  <div class="col-1"></div>
  <div class="col d-flex align-items-center">
    <div translate>NAME</div>
  </div>
  <div class="col-1 d-flex align-items-center">
    <div translate>VOLUME</div>
  </div>
  <div class="col-2 d-flex align-items-center justify-content-center">
    <div class="text-center" translate>REQUESTED_QUANTITY</div>
  </div>
  <div class="col-2 d-flex align-items-center justify-content-center">
    <div class="text-center" translate>UNIT_PRICE</div>
  </div>
  <div class="vhr col-2 d-flex align-items-center justify-content-center flex-column">
    <div translate>TOTAL_PRICE</div>
  </div>
</div>
<div class="row hr mt-2"></div>
<div class="row">
  <div class="col-12" *ngFor="let item of items">
    <ng-template libCustomHost></ng-template>
  </div>
</div>
